import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom/dist";


const PageHeaderWithRoutes = ({ heading, desc, tabs }) => {
    const navigate = useNavigate();
    return (
        <>
            <div className="container newPagesHeader" 
            // style={{display:"flex",justifyContent:"space-evenly",alignItems:"center"}}
            >
                {/* <div> */}

                    {/* <FontAwesomeIcon style={{ cursor: "pointer" }} fontSize={20} onClick={() => navigate(-1)} icon={faArrowLeft} /> */}
                    {/* <h1 className="bold text-center title">{heading}</h1> */}
                    {/* <p className="text-center desc">{desc}</p> */}
                {/* </div> */}

                <div className="tabs_wrap">
                    {tabs && tabs.length && tabs.map((e, index) => (

                        // <NavLink to={e.route} className="tabs" activeClassName="active">{e.name}</NavLink> 
                        <NavLink to={e.route} className="tabs" activeClassName="active">
                            <img src={e.imgSrc} style={{ width: "50px", height: "50px", objectFit: "contain" }} />
                            {e.name}</NavLink>

                    ))}

                </div>


            </div>


        </>
    );
};

export default PageHeaderWithRoutes;
